<template>
  <a-modal :visible="filters.visible" :title="$t('page_alarm_detail')" @cancel="cancel" :width="1100" :footer="null">
    <div>
      <ml-table
        style="margin-bottom: 32px"
        size="small"
        :columns="columns"
        :dataSource="filters.data"
      ></ml-table>
      <a-pagination
        style="position: absolute; right: 6px; bottom: 12px"
        :total="filters.total"
        :pageSize="filters.size"
        :current="filters.current"
        @change="pageIndexchange"
        :showTotal="(totalContent) => `${totalFanyi(totalContent)}`"
      ></a-pagination>
    </div>
  </a-modal>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_station_comprehensive_working_time'),
          key: 'loginTime',
          dataIndex: 'loginTime',
          customRender: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          title: this.$t('page_station_comprehensive_off_time'),
          key: 'logoutTime',
          dataIndex: 'logoutTime',
          customRender: (text) => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss'): '--'
        },{
          title: this.$t('page_shift_model_shift'),
          key: 'shiftIndexName',
          dataIndex: 'shiftIndexName',
        },
        {
          title: this.$t('page_station_comprehensive_poor_yield'),
          key: 'yield',
          dataIndex: 'yield'
        },{
          title: this.$t('page_station_comprehensive_working_hours') + "(h)",
          key: 'workingHours',
          dataIndex: 'workingHours'
        },{
          title: this.$t('page_station_comprehensive_running_time') + "(h)",
          key: 'runningTime',
          dataIndex: 'runningTime'
        },{
          title: this.$t('page_station_comprehensive_avg_yield') + "(h)",
          key: 'avgYield',
          dataIndex: 'avgYield'
        },{
          title: this.$t('page_station_comprehensive_processing_efficiency'),
          key: 'efficiency',
          dataIndex: 'efficiency'
        }
      ]
    }
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    pageIndexchange(size) {
      this.$emit('pageIndexchange', size)
    },
    totalFanyi(number) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    }
  }
}
</script>

<style lang="less" scoped>
.ant-modal-body {
  position: relative;
}
</style>
